const peiServiceNeedCodes = {
  communicationAssistant: 86,
  notConsideredAssistant: 87,
  feedingAssistant: 1929,
  hygieneAssistant: 1930,
  mobilityAssistant: 1932,
  transportationAssistant: 1937,
  healthAssistantCateterism: 1992,
  healthAssistantDiabetes: 1993,
  healthAssistantAnxiety: 1994,
  healthAssistantColostomy: 1995,
  healthAssistantGastrostomy: 1996,
  healthAssistantMedication: 1997,
};

export default peiServiceNeedCodes;
